<template>
  <select
    v-if="item"
    v-model="item.stage"
    :value="item.stage"
    :key="item.stage"
    :class="{
      'bg-red-200 border-red-300 text-red-900 text-bold': item.stage === PRODUCTION_STAGES.BACKLOG,
      'bg-orange-200 border-orange-300 text-orange-900 text-bold': item.stage === PRODUCTION_STAGES.DECOUPAGE,
      'bg-indigo-200 border-indigo-300 text-indigo-900 text-bold': item.stage === PRODUCTION_STAGES.POLISSAGE,
      'bg-green-200 border-green-300 text-green-900 text-bold': item.stage === PRODUCTION_STAGES.FINI,
    }"
    class="block font-semibold min-w-96 sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-2 border-solid rounded-md px-2 pr-8 py-2"
  >
    <option
      v-for="stage in Object.values(PRODUCTION_STAGES)"
      :key="stage"
      :selected="item.stage === stage"
      :value="stage"
    >
      {{ stage }}
    </option>
  </select>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { useVModel, watchDebounced } from '@vueuse/core'

import PRODUCTION_STAGES from '@/constants/PRODUCTION_STAGES'
import useApi from '@/hooks/useApi'

const props = defineProps({
  modelValue: Object,
})

const api = useApi()
const emit = defineEmits(['update:modelValue'])

const item = useVModel(props, 'modelValue', emit)

watchDebounced(
  () => item.value?.stage,
  (newStage, oldStage) => {
    if (newStage === oldStage) return
    api.production.setStage({ id: item.value?.production_id || item.value?.id, stage: newStage }).then(() => {
      item.stage = newStage
      const now = new Date().toISOString()
      item.updated_datetime = now
    })
  },
  { debounce: 300 },
)
</script>
